import * as yup from "yup";

export const demoSchema = yup.object().shape({
  fullname: yup.string().min(3).required(),
  email: yup.string().email().required(),
  companyName: yup.string().min(3).required(),
  demoDate: yup.date().nullable(),
  message: yup.string().max(300),
});
export const contactSchema = yup.object().shape({
  fullname: yup.string().min(3).required(),
  email: yup.string().email().required(),
  phone: yup.string().required(),
  subject: yup
    .string()
    .required()
    .max(50, "Subject must be at most 50 characters"),
  message: yup.string().max(300),
});
